import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { getAllSizes } from '../app/features/size/sizeSlice';

const Receipt = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();

  useEffect(() => {
    dispatch(getAllSizes());
  }, [dispatch]);

  const authState = useSelector((state) => state?.auth);

  const {
    orderDetails,
    shippingInfo,
    orderItems,
    paymentInfo,
    totalAmount,
    shippingCost,
  } = state || {};

  if (!orderDetails) {
    return <p>No order details found.</p>;
  }

  return (
    <div className="receipt-container">
      <h2>Thank You for your Order!</h2>

      <p className="emsent">
        We've emailed your receipt to <strong>{authState?.user?.email}</strong>
      </p>

      <Link to="/my-orders" className="button noww">
        View Order
      </Link>

      <div className="order-info">
        <p>
          <strong>Date:</strong> {new Date().toLocaleDateString()}
        </p>
        <p>
          <strong>Order ID:</strong> {orderDetails?.order?._id}
        </p>
      </div>

      <div className="order-items">
        <h3>Order Items:</h3>
        <ul>
          {(orderItems || []).map((item, index) => (
            <li className="list-sty" key={index}>
              <div>
                <div className="receipt-img">
                  <img
                    src={item?.product?.images?.[0]?.url || '/path/to/default-image.jpg'}
                    alt={item?.product?.title || 'Product Image'}
                    className="w-100"
                  />
                </div>

                <p className="mb-10 mt-10">
                  <strong>{item?.product?.title}</strong>
                </p>

                <p
                  dangerouslySetInnerHTML={{
                    __html: item?.product?.description || '',
                  }}
                />

                <p className="mt-10">Quantity: {item?.quantity}</p>
                <p>Price: UGX {(item?.price || 0) * (item?.quantity || 0)}</p>

                {item?.size && <p>Size: {item?.size?.title}</p>}

                {item?.uploadedFiles && item.uploadedFiles.length > 0 && (
                  <div className="uploaded-files">
                    <p>Files:</p>
                    <ul>
                      {item.uploadedFiles.map((file, fileIndex) => (
                        <li className="list-st" key={fileIndex}>
                          {file?.fileName}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {item?.color?.title && (
                  <div className="col-1 mb-5">
                    <ul className="colors font-rec">
                      Color <li style={{ backgroundColor: item?.color?.title }}></li>
                    </ul>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="shipping-info">
        <h3>Shipping Information:</h3>
        <p>
          Name: {shippingInfo?.firstName} {shippingInfo?.lastName}
        </p>
        <p>
          Address: {shippingInfo?.address}, {shippingInfo?.region},{' '}
          {shippingInfo?.subRegion}
        </p>
      </div>

      <div className="payment-info">
        <h3>Payment Information:</h3>
        <p>
          <strong>Payment Method:</strong> {paymentInfo?.paymentMethod}
        </p>
      </div>

      <div className="totals">
        <p className="torece">
          <strong>Total:</strong> UGX {(totalAmount || 0) + (shippingCost || 0)}
        </p>
      </div>
    </div>
  );
};

export default Receipt;